import { useRef } from 'react';
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Swal from 'sweetalert2';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_x6gb1jt', 'template_u4famdf', form.current, {
        publicKey: 'w_SdFxnpj1wnZZvdM',
      })
      .then(
        () => {
          Swal.fire({
            title: "Skickats",
            text: "Meddelandet har skickats",
            icon: "Success"
        });
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  return (
    <div>
        <section id='contact' className='contact_us'>
            <div className='content_us'>
                <h2>Kontakta Oss</h2>
            </div>
            <div className='container_us'>
                <div className='contactInfo'>
                    <div className='box'>
                        <div className='icon_contact'><FaPhone /></div>
                        <div className='text'>
                            <h3>Nummer</h3>
                            <p>072 275 55 97 </p>
                        </div>
                    </div>
                    <div className='box'>
                        <div className='icon_contact'><MdEmail /></div>
                        <div className='text'>
                            <h3>Email</h3>
                            <p>Primafreshfrukt.gront@gmail.com</p>
                        </div>
                    </div>
                </div>
                <div className='contactForm'>
                    <form ref={form} onSubmit={sendEmail}>
                        <div className='inputBox'>
                            <input type='text' className='text' name='name' placeholder='Namn' required='required' />
                        </div>
                        <div className='inputBox'>
                            <input type='text' className='text' name='email' placeholder='Email' required='required' />
                        </div>
                        <div className='inputBox'>
                            <input name='message' className='text' placeholder='Meddelande' required='required' />
                        </div>
                        <div className='inputBox'>
                            <button type='submit'>Skicka</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Contact